import type { FC } from 'react';

const BurgerMenuIcon: FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16" fill="none">
    <path
      d="M1 1H23M1 8H23M1 15H23"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BurgerMenuIcon;
